import {
  getAuditLogDetails,
  getAuditLogCategories,
  postUserComments
} from "@/common/service/apiaggregator/auditAgreegatorService";
import { getAuditNotificationDetails } from "@/common/service/apiaggregator/notificationAgreegatorService";

const state = {
  auditLogList: [],
  categoriesList: [],
  selectedCompliance: {},
  selectedNotificationDetails: {},
  complianceWithLinkedDates: null,
  routeLink: {},
  auditLogListLoader: false,
  auditLogListError: null,
  complianceId: "",
  bolNumber: "",
  firstEventLinkedDate: "",
  nextCursor: "",
  categories: ["Status History", "UI Updates", "Validation Issue"],
  prevCursor: "",
  showNextPage: false,
  showPreviousPage: false,
  recordPerPage: 10
};

const mutations = {
  setAuditLogList(state, result) {
    state.auditLogList = result;
  },
  setCategoriesList(state, result) {
    state.categoriesList = result;
  },
  setSelectedNotificationDetails(state, result) {
    state.selectedNotificationDetails = result;
  },
  setComplianceWithLinkedDates(state, result) {
    state.complianceWithLinkedDates = result;
  },
  setSelectedCompliance(state, result) {
    state.selectedCompliance = result;
  },
  setRouteLink(state, result) {
    state.routeLink = result;
  },
  setNextCursor(state, result) {
    state.nextCursor = result;
  },
  setCurrentPage(state, result) {
    state.currentPage = result;
  },
  setShowNextPage(state, result) {
    state.showNextPage = result;
  },
  setRecordPerPage(state, result) {
    state.recordPerPage = result;
  },
  setPrevCursor(state, result) {
    state.prevCursor = result;
  },
  setShowPreviousPage(state, result) {
    state.showPreviousPage = result;
  },
  setFilterCategories(state, result) {
    state.categories = result;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setComplianceId(state, value) {
    state.complianceId = value;
  },
  setBolNumber(state, value) {
    state.bolNumber = value;
  },
  setFirstEventLinkedDate(state, value) {
    state.firstEventLinkedDate = value;
  }
};
const actions = {
  async fetchAuditLog({ commit }, params) {
    commit("setAuditLogList", []);
    commit("setLoadingState", { type: "auditLogList", value: true });
    try {
      let rawData,
        data = [];
      const { nextCursor, prevCursor, isDeletedCompliance = false } = params;
      const nxtCrsr = nextCursor || "";
      const prevCrsr = prevCursor || "";
      const reqParams = {
        complianceId: state.complianceId,
        firstEventLinkedDate: state.firstEventLinkedDate,
        bolNumber: state.bolNumber,
        nextCursor: nxtCrsr,
        prevCursor: prevCrsr,
        limit: state.recordPerPage,
        categories: state.categories.toString(),
        isDeletedCompliance
      };

      rawData = await getAuditLogDetails(reqParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "auditLogList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (data.content) {
        // TODO: temporary fix , Backend pagination should implement
        if (isDeletedCompliance) {
          if (nextCursor) {
            commit("setCurrentPage", state.currentPage + 1);
          } else if (prevCursor) {
            commit("setCurrentPage", state.currentPage - 1);
          }

          const totalPages = Math.ceil(data.content.length / state.recordPerPage);
          const start = (state.currentPage - 1) * state.recordPerPage;
          const end = start + state.recordPerPage;
          const paginationData = data.content.slice(start, end);

          commit("setAuditLogList", paginationData);
          commit("setShowNextPage", state.currentPage !== totalPages);
          commit("setNextCursor", state.currentPage !== totalPages);
          commit("setShowPreviousPage", state.currentPage !== 1);
          commit("setPrevCursor", state.currentPage !== 1);
          commit("setErrorState", { type: "auditLogList", error: "" });
          commit("setLoadingState", { type: "auditLogList", value: false });
          return;
        } else {
          commit("setAuditLogList", data.content);
        }
      }

      if (data.showNextPage) {
        commit("setShowNextPage", data.nextCursor);
      } else {
        commit("setShowNextPage", false);
      }

      if (data.showPreviousPage) {
        commit("setShowPreviousPage", data.showPreviousPage);
      } else {
        commit("setShowPreviousPage", false);
      }

      if (data.nextCursor) {
        commit("setNextCursor", data.nextCursor);
      } else {
        commit("setNextCursor", "");
      }

      if (data.prevCursor) {
        commit("setPrevCursor", data.prevCursor);
      } else {
        commit("setPrevCursor", "");
      }
      commit("setErrorState", { type: "auditLogList", error: "" });
      commit("setLoadingState", { type: "auditLogList", value: false });
    } catch (error) {
      commit("setAuditLogList", []);
      commit("setErrorState", { type: "auditLogList", error });
      commit("setLoadingState", { type: "auditLogList", value: false });
    }
  },
  async fetchAuditFilterCategories({ commit }) {
    commit("setLoadingState", { type: "filterCategories", value: true });
    try {
      let rawData,
        data = [];

      rawData = await getAuditLogCategories(true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "filterCategories",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (data) {
        commit("setCategoriesList", data);
      }
      commit("setErrorState", { type: "filterCategories", error: "" });
      commit("setLoadingState", { type: "filterCategories", value: false });
    } catch (error) {
      commit("setAuditLogList", []);
      commit("setErrorState", { type: "filterCategories", error });
      commit("setLoadingState", { type: "filterCategories", value: false });
    }
  },
  async fetchNotificationDetails({ commit }, ediTransmissionId) {
    commit("setSelectedNotificationDetails", {});
    commit("setLoadingState", { type: "notificationDetails", value: true });
    try {
      let rawData,
        data = [];

      rawData = await getAuditNotificationDetails(ediTransmissionId, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationDetails",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (data) {
        commit("setSelectedNotificationDetails", data);
      }
      commit("setErrorState", { type: "notificationDetails", error: "" });
      commit("setLoadingState", { type: "notificationDetails", value: false });
    } catch (error) {
      commit("setAuditLogList", []);
      commit("setErrorState", { type: "notificationDetails", error });
      commit("setLoadingState", { type: "notificationDetails", value: false });
    }
  },
  async addUserComments({ commit, rootState, dispatch }, params) {
    commit("setLoadingState", { type: "addComments", value: true });
    try {
      let rawData;
      let complianceWithLinkedDates;
      if (!params.updateAllComp) {
        complianceWithLinkedDates = [
          {
            complianceId: state.complianceId,
            firstEventLinkedDate: state.firstEventLinkedDate
          }
        ];
      } else {
        dispatch("getComplianceList", state.bolNumber);
        complianceWithLinkedDates = state.complianceWithLinkedDates;
      }
      const req_body = {
        bolNumber: state.bolNumber,
        message: params.message,
        userName:
          rootState.userAccount.loginDetails.name +
          " (" +
          rootState.userAccount.loginDetails.idTokenClaims.MaerskID +
          ")",
        complianceWithLinkedDates
      };

      rawData = await postUserComments(req_body);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "addComments",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      dispatch("fetchAuditLog", { nextCursor: "", prevCursor: "" });
      commit("setErrorState", { type: "addComments", error: "" });
      commit("setLoadingState", { type: "addComments", value: false });
    } catch (error) {
      commit("setAuditLogList", []);
      commit("setErrorState", { type: "addComments", error });
      commit("setLoadingState", { type: "addComments", value: false });
    }
  },
  async initialFetchAuditLog({ dispatch, commit }, params) {
    const { compliance = {}, isDeletedCompliance, bolNumber, routeLink = {} } = params;
    commit("setBolNumber", bolNumber);
    commit("setComplianceId", compliance.complianceId);
    commit("setFirstEventLinkedDate", compliance.firstEventLinkedDate);
    commit("setSelectedCompliance", compliance);
    commit("setRouteLink", routeLink);
    commit("setRecordPerPage", 10);
    commit("setPrevCursor", "");
    commit("setNextCursor", "");
    commit("setCurrentPage", 1);
    const filterItems = ["Status History", "UI Updates", "Validation Issue"];
    commit("setFilterCategories", filterItems);
    dispatch("fetchAuditFilterCategories");
    dispatch("fetchAuditLog", { nextCursor: "", prevCursor: "", isDeletedCompliance });
  },
  async updateRecordPage({ dispatch, commit }, recordPerPageData) {
    const { recordPerPage, deletedManifestFlag } = recordPerPageData;
    commit("setRecordPerPage", recordPerPage);
    commit("setPrevCursor", "");
    commit("setNextCursor", "");
    commit("setCurrentPage", 1);
    dispatch("fetchAuditLog", { nextCursor: "", prevCursor: "", isDeletedCompliance: deletedManifestFlag });
  },
  async nextPagePagination({ dispatch }, deletedManifestFlag) {
    dispatch("fetchAuditLog", {
      nextCursor: state.nextCursor,
      prevCursor: "",
      isDeletedCompliance: deletedManifestFlag
    });
  },
  async getComplianceList({ commit, rootState }, bolNumber) {
    const complianceList = [];
    if (rootState.bolDetails.bolRecords) {
      for (const shipmentItem of rootState.bolDetails.bolRecords.shipments) {
        if (shipmentItem.shipmentNumber === bolNumber) {
          for (const routeItem of shipmentItem.route.routeLinks) {
            for (const compItem of routeItem.compliances) {
              let tempItem = {
                complianceId: compItem.complianceId,
                firstEventLinkedDate: compItem.firstEventLinkedDate
              };
              complianceList.push(tempItem);
            }
          }
        }
      }
    }

    commit("setComplianceWithLinkedDates", complianceList);
  },
  async prevPagePagination({ dispatch }, deletedManifestFlag) {
    dispatch("fetchAuditLog", {
      prevCursor: state.prevCursor,
      nextCursor: "",
      isDeletedCompliance: deletedManifestFlag
    });
  },
  async filterUpdation({ dispatch, commit }, filterData) {
    const { filterList, deletedManifestFlag } = filterData;

    commit("setFilterCategories", filterList);
    commit("setPrevCursor", "");
    commit("setNextCursor", "");
    commit("setCurrentPage", 1);
    dispatch("fetchAuditLog", { nextCursor: "", prevCursor: "", isDeletedCompliance: deletedManifestFlag });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
